import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { TripFilter } from '../../../models/trips/tripFilter';

@Component({
	selector: 'trip-filter',
	templateUrl: './trip-filter.component.html',
	styleUrls: ['./trip-filter.component.css']
})
export class TripFilterComponent implements OnInit {
	showFilter: boolean = false;

	@Input() filter: TripFilter = new TripFilter();
	@Output() search: EventEmitter<TripFilter> = new EventEmitter<TripFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
		this.filter.clientId = null;
		this.filter.shippingLineId = null;
		this.filter.createdBy = null;
		this.filter.isDone = null;
		this.filter.isPaid = null;
		this.filter.containerNumber = undefined;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/trips/trip-filter/trip-filter.component.ts